// routes
import { Roles, allowRoleToSeeDevTab, routeRoleAsAdmin } from './assets/data';
import brandConfig from './config/brandConfig';
import { PATH_ADMIN, PATH_HOME } from './routes/paths';
import { CheckEnvironment, CheckLocalDev, SupportedEnvironments } from './utils/environment';

// Re-export for backward compatibility
export { CheckEnvironment, CheckLocalDev, SupportedEnvironments };

// API
// ----------------------------------------------------------------------
export const HOST_API_KEY = process.env.REACT_APP_HOST_API_KEY || '';

export const FIREBASE_API = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export const COGNITO_API = {
  userPoolId: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID,
  clientId: process.env.REACT_APP_AWS_COGNITO_CLIENT_ID
};

export const AUTH0_API = {
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN
};

export const MAP_API = process.env.REACT_APP_MAPBOX_API;

export const STRIPE_PUBLISHABLE_KEY = brandConfig.stripePublishableKey;

export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
export const SENTRY_ENABLED = process.env.REACT_APP_SENTRY_ENABLED === 'true';

// Dynamically set GCF base URL based on emulator configuration
// This ensures axios calls (like downloadStatement) use the emulator when enabled
// Note: Emulator requires full path: http://localhost:3000/{projectId}/{region}
const shouldConnectToEmulator = CheckLocalDev() && process.env.REACT_APP_ENABLE_EMULATOR === 'true';
export const GCF_BASE_URL = shouldConnectToEmulator
  ? 'http://localhost:3000/owners-portal-dev-2ba44/us-central1'
  : process.env.REACT_APP_GCF_BASE_URL;

// Portal Notifications - Allow superusers to see portal notifications (normally disabled)
export const SUPERUSER_PORTAL_NOTIFICATIONS =
  process.env.REACT_APP_SUPERUSER_PORTAL_NOTIFICATIONS === 'true';

// default landing after login successful
export const WritePostLoginPath = (role: Roles) => {
  return routeRoleAsAdmin(role) || allowRoleToSeeDevTab(role)
    ? PATH_ADMIN.user.list
    : PATH_HOME.general.app;
};

// LAYOUT
// ----------------------------------------------------------------------

export const HEADER = {
  H_MOBILE: 64,
  H_MAIN_DESKTOP: 88,
  H_DASHBOARD_DESKTOP: 92,
  H_DASHBOARD_DESKTOP_OFFSET: 92 - 32
};

export const NAV = {
  W_BASE: 260,
  W_DASHBOARD: 280,
  W_DASHBOARD_MINI: 88,
  //
  H_DASHBOARD_ITEM: 48,
  H_DASHBOARD_ITEM_SUB: 36,
  //
  H_DASHBOARD_ITEM_HORIZONTAL: 32
};

export const ICON = {
  NAV_ITEM: 24,
  NAV_ITEM_HORIZONTAL: 22,
  NAV_ITEM_MINI: 22
};
